import React from "react";
import { useTranslation } from "react-i18next";
import ImgComponent from "../../ImgComponent";
import getCycleCardImagePath from "../../../utils/get-cycle-card-image-path";

const LearnMoreHeader = ({ program, fromAthlete, athlete }) => {
  const { t } = useTranslation("coaching-portal");
  const imgPath = getCycleCardImagePath(program);
  const [errotImg, setErrorImg] = React.useState(false);
  return (
    <div className={`image-background-overlay ${errotImg ? "error" : ""}`}>
      <ImgComponent
        image={imgPath}
        altText={t("learnMoreHeader.altProgramThumbnail")}
        onErrorFn={() => setErrorImg(true)}
        classNames={`program-image ${
          imgPath.startsWith("data:image") ? "no-image" : ""
        }`}
      />
      <a
        href={`/actions/refresh?modal=`}
        role="button"
        data-button-type="tertiary"
        data-icon-only="true"
      >
        <img
          src="/img/new-icons/red-cross.svg"
          alt={t("learnMoreHeader.altDismiss")}
        />
      </a>
    </div>
  );
};

export default LearnMoreHeader;
